import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { accountSupportUri } from 'Consts/advisorUris';
import {
  HouseholdBalanceSheetFilters,
} from 'Views/Page/Content/Templates/HouseholdBalanceSheetPageTemplate/filters/HouseholdBalanceSheetFilters';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useLayoutContext } from 'Context/LayoutContext';

export const HouseholdBalanceSheetPageActions = ({
  collection,
  setCollection,
  onToggleExpandAll,
  atLeastOneOpen,
  history,
  householdResource,
  balanceSheetResource,
  onAddAccount,
  onViewConnectionsPage,
}) => {
  const { isFocusedLayout } = useLayoutContext();
  const isMobile = useMobileLayout();
  const left = (
    <>
      {!isMobile && (
        <FDSecondaryActionButton
          {...dataAttrs(`household-balance-sheet-${atLeastOneOpen ? 'collapse-all' : 'expand-all'}`)}
          size="sm"
          onClick={onToggleExpandAll}
          label={atLeastOneOpen ? 'Collapse all' : 'Expand all'}
          icon={atLeastOneOpen ? 'keyboardArrowUp' : 'keyboardArrowDown'}
          iconPosition="start"
        />
      )}
      <HouseholdBalanceSheetFilters collection={collection} setCollection={setCollection} />
    </>
  );
  const right = (
    <>
      {balanceSheetResource.withRelationship(fr.relationships.connectionsPage.name, (rel) => {
        return (
          <FDPrimaryActionButton
            icon={'accountBalance'}
            label={rel.meta('prompt')}
            onClick={() => onViewConnectionsPage(rel)}
            size={'sm'}
            {...dataAttrs('manage-connections-action-btn')}
          />
        );
      }, () => null)}
      {balanceSheetResource.withRelationship(fr.relationships.plaidLinkSessions.name, (rel) => {
        // In focused layout, this button feels out of place, but also, it lets you escape the forced focus mode, which is bad for guidedHouseholdReview
        if (isFocusedLayout) {
          return null;
        }

        return (
          <FDPrimaryActionButton
            label={rel.meta('prompt')}
            onClick={() => history.push(accountSupportUri(householdResource.id(), rel.link('related').url()))}
            size={'sm'}
            {...dataAttrs('plaid-link-sessions')}
          />
        );
      }, () => null)}
      {balanceSheetResource.withRelationship(fr.relationships.addAccounts.name, (rel) => {
        return (
          <FDPrimaryActionButton
            icon={'add'}
            label={rel.meta('prompt')}
            onClick={() => onAddAccount(rel)}
            size={'sm'}
            {...dataAttrs('add-manually-action-btn')}
          />
        );
      }, () => null)}
    </>
  );

  // Mobile just gets all the buttons running together, but on larger screens (or MC) we want to try to separate the sections of buttons visually
  if (isMobile) {
    return <FDStack wrap spacing={1} alignItems="center">{left}{right}</FDStack>;
  }
  return (
    <FDStack direction="row" spacing={3} alignItems="center" justifyContent="space-between">
      <FDStack wrap spacing={1}>{left}</FDStack>
      <FDStack wrap={isMobile} spacing={1}>{right}</FDStack>
    </FDStack>
  );
};

HouseholdBalanceSheetPageActions.defaultProps = {
};

HouseholdBalanceSheetPageActions.propTypes = {
  collection: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
  onToggleExpandAll: PropTypes.func.isRequired,
  atLeastOneOpen: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  balanceSheetResource: PropTypes.object.isRequired,
  onAddAccount: PropTypes.func.isRequired,
  onViewConnectionsPage: PropTypes.func.isRequired,
};
